import { createAction, ActionCreator } from "redux-act";

export const fetchPicklistData: ActionCreator<Record<string, any>> = createAction(
    "GET_PICKLIST_DATA",
    (picklists) => picklists
);
export const fetchedPicklistData: ActionCreator<Record<string, any>> =
    createAction("GET_PICKLIST_SUCCESS");
export const clearPicklistState = createAction("CLEAR_PICKLIST_STATE");
